export { ContactPage as default, getServerSideProps } from "~/wrappers/ContactPage";
